import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import IndividualTickets from "./IndividualTickets";
import GroupPurchase from "./GroupPurchase";
import PackagePurchase from "./PackagePurchase";

export default function Stats({ data, jsonData }) {
  if (!data) return "";

  return (
    <>
      <Row id="stats">
        <Col xs={4}>
          <IndividualTickets data={data} jsonData={jsonData} />
        </Col>
        <Col xs={4}>
          <GroupPurchase data={data} jsonData={jsonData} />
        </Col>
        <Col xs={4}>
          <PackagePurchase data={data} jsonData={jsonData} />
        </Col>
      </Row>
    </>
  );
}
